import { ThrowStmt } from "@angular/compiler";
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ThrottlingUtils } from "@azure/msal-common";
import { SingleEmailValidator } from "src/app/directives/multi-email.directive";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { Reseller } from "src/app/models/Reseller/Reseller";
import { UtilitiesService } from "src/app/services/utilities.service";
import Swal from "sweetalert2";

@Component({
	selector: "app-reseller-entry",
	templateUrl: "./reseller-entry.component.html",
	styleUrls: ["./reseller-entry.component.scss"],
})
export class ResellerEntryComponent implements OnInit {
	public loading: boolean = false;
	public resellerFormGroup: FormGroup;
	@Input() public detailMode: boolean = false;
	@Input() public editMode: boolean = false;
	@Input() public resellerToEdit: Reseller = undefined;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendResellerRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	public resellerObj: Reseller = new Reseller();
	public files: File[] = [];
	constructor(private formBuilder: FormBuilder, private ref: ChangeDetectorRef, private utilities: UtilitiesService) {
		this.setResellerForm();
	}

	ngOnInit(): void {
		if ((this.editMode || this.detailMode) && this.resellerToEdit.resellerId) {
			this.resellerObj = { ...this.resellerToEdit };
			this.fillResellerFormData(this.resellerObj);
		}
		if (this.detailMode) this.resellerFormGroup.controls.logoCompleteFile.disable();
	}

	setResellerForm() {
		this.resellerFormGroup = this.formBuilder.group({
			rutCompleto: [, [Validators.required, VerificacionRutValidator]],
			razonSocial: [, Validators.required],
			domicilio: [, Validators.required],
			comuna: [, Validators.required],
			ciudad: [, Validators.required],
			nombreContacto: [, Validators.required],
			telefonoContacto: [, Validators.required],
			emailContacto: ["", [Validators.required, SingleEmailValidator]],
			logoCompleteFile: [],
			usarLogo: [false],
		});
	}

	fillResellerFormData(reseller: Reseller) {
		this.resellerFormGroup.patchValue(reseller);
		this.resellerFormGroup.controls.rutCompleto.patchValue(reseller.rutCompleto);
		this.resellerFormGroup.controls.razonSocial.patchValue(reseller.razonSocial);
		this.resellerFormGroup.controls.domicilio.patchValue(reseller.domicilio);
		this.resellerFormGroup.controls.comuna.patchValue(reseller.comuna);
		this.resellerFormGroup.controls.ciudad.patchValue(reseller.ciudad);
		this.resellerFormGroup.controls.nombreContacto.patchValue(reseller.nombreContacto);
		this.resellerFormGroup.controls.telefonoContacto.patchValue(reseller.telefonoContacto);
		this.resellerFormGroup.controls.emailContacto.patchValue(reseller.emailContacto);
		this.resellerFormGroup.controls.usarLogo.patchValue(reseller.usarLogo);
	}

	onSubmit() {
		if (this.resellerFormGroup.valid) {
			this.getResellerFormData();
			this.sendResellerRequestEmitter.emit(this.resellerObj);
		}
	}

	getResellerFormData() {
		this.resellerObj.rutCompleto = this.resellerFormGroup.controls.rutCompleto.value;
		this.resellerObj.rut = parseInt(this.resellerObj.rutCompleto.substring(0, this.resellerObj.rutCompleto.length - 2));
		this.resellerObj.dv = this.resellerObj.rutCompleto.substring(this.resellerObj.rutCompleto.length - 1);
		this.resellerObj.razonSocial = this.resellerFormGroup.controls.razonSocial.value;
		this.resellerObj.domicilio = this.resellerFormGroup.controls.domicilio.value;
		this.resellerObj.comuna = this.resellerFormGroup.controls.comuna.value;
		this.resellerObj.ciudad = this.resellerFormGroup.controls.ciudad.value;
		this.resellerObj.nombreContacto = this.resellerFormGroup.controls.nombreContacto.value;
		this.resellerObj.telefonoContacto = this.resellerFormGroup.controls.telefonoContacto.value;
		this.resellerObj.emailContacto = this.resellerFormGroup.controls.emailContacto.value;
		this.resellerObj.logoCompleteFile = this.resellerFormGroup.controls.logoCompleteFile.value;
		this.resellerObj.usarLogo = this.resellerFormGroup.controls.usarLogo.value != undefined ? this.resellerFormGroup.controls.usarLogo.value : false;
	}

	onSelect(event) {
		var fileExtensionName = this.getName(event);
		if (event.rejectedFiles[0] || (fileExtensionName.toLowerCase() != "png" && fileExtensionName.toLowerCase() != "jpg" && fileExtensionName.toLowerCase() != "jpeg")) {
			Swal.fire({
				icon: "error",
				title: "Error de Archivo",
				text: "El archivo ingresado no es de formato de imagen .JPG o .PNG, favor agregar un archivo con el formato correcto. Razón: " + event.rejectedFiles[0].reason == "size" ? "Tamaño" : "Tipo de archivo",
			});
		}

		this.files.push(...event.addedFiles);
		if (this.files.length > 1) {
			this.files.shift();
		}
		this.resellerFormGroup.controls.logoCompleteFile.patchValue(this.files[0]);
		this.resellerObj.logoCompleteFile = this.files[0];

		// if (this.editMode) {
		//    this.resellerToEdit.logoCompleteFile = this.files[0];
		// } else {
		//    this.resellerObj.logoCompleteFile = this.files[0];
		// }
		this.loading = true;
		this.utilities
			.convertFileToB64String(this.files[0])
			.then((data) => {
				this.resellerObj.logoFile = data.split(",")[1];

				// if (this.editMode) {
				//    this.resellerToEdit.logoFile = data.split(",")[1];
				// } else {
				//    this.resellerObj.logoFile = data.split(",")[1];
				// }
				this.loading = false;
				this.ref.detectChanges();
			})
			.catch(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	getName(event): string {
		if (event.addedFiles) {
			return event.addedFiles[0].name.split(".").pop();
		} else if (event.rejectedFiles) {
			return event.rejectedFiles[0].name.split(".").pop();
		} else {
			return "";
		}
	}

	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
		this.resellerFormGroup.controls.logoFile.patchValue(null);
	}
	closeResellerModal() {
		this.sendCloseRequestEmitter.emit();
	}
}
